import { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getCurricula } from '../services/CurriculumService';
import { Mixpanel } from '../services/Mixpanel';
import {
  allCurricula,
  registerCurricula,
  toCurricula,
  visibleCurricula,
} from '../utils/curriculum';

/**
 * The curricula the picker offers this teacher, once the published index loads:
 * every public one, plus the restricted ones the `extra-curricula` flag names.
 *
 * A failed index request leaves the list empty; opening the curriculum flyout
 * again retries. A loaded index is reused, so reopening costs nothing.
 *
 * @param {boolean} enabled - load only while the curriculum menu can show
 * @param {boolean} [open] - the curriculum flyout is open
 */
export const useCurricula = (enabled, open = false) => {
  const { extraCurricula } = useFlags();
  const [curricula, setCurricula] = useState(allCurricula);

  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    getCurricula()
      .then((entries) => {
        registerCurricula(toCurricula(entries));
        if (live) setCurricula(allCurricula());
      })
      .catch(() => {
        // This axios instance has no error interceptor, so Sentry never sees it.
        Mixpanel.track('Align Curriculum Load Failed', { resource: 'curricula.json' });
      });
    return () => {
      live = false;
    };
  }, [enabled, open]);

  return visibleCurricula(curricula, extraCurricula);
};
